import React from "react";

import { Button, Col, Form, Row, Select } from "antd";

import { useTranslation } from "react-i18next";

import { PlusOutlined } from "@ant-design/icons";

import LocationPicker from "../../../../components/pickers/LocationPicker";
import { useSelector } from "react-redux";
import { makeSelectLanguage, makeSelectWaypointLocations } from "../../../../containers/App/selectors";
import getLocalizedName from "../../../../utils/getLocalizedName";

type Props = {
  openWaypointLocation: boolean;
};

const LocationsFormItems = React.memo(({ openWaypointLocation }: Props) => {
  const { t } = useTranslation("translations");

  const lang = useSelector(makeSelectLanguage());

  const waypointLocations = useSelector(makeSelectWaypointLocations());

  const [showWaypointSelect, setShowWaypointSelect] = React.useState(openWaypointLocation);

  return (
    <Row gutter={8}>
      <Col flex={1} span={showWaypointSelect ? 8 : undefined}>
        <Form.Item name="fromLocation" rules={[{ required: true, message: t("choose_from") }]} label={t("from_location_with_options")}>
          <LocationPicker filterPredicate={(location) => location.type !== "UNKNOWN"} allowCreateNewLocation />
        </Form.Item>
      </Col>

      {showWaypointSelect ? (
        <Col span={8}>
          <Form.Item name="waypointLocationId" label={t("intermediate_location_with_options")}>
            <Select
              options={waypointLocations.map((x) => ({
                value: x.id,
                label: getLocalizedName(x, lang),
              }))}
            />
          </Form.Item>
        </Col>
      ) : (
        <Col>
          <Form.Item label=" ">
            <Button icon={<PlusOutlined />} onClick={() => setShowWaypointSelect(true)} />
          </Form.Item>
        </Col>
      )}

      <Col flex={1} span={showWaypointSelect ? 8 : undefined}>
        <Form.Item name="toLocation" rules={[{ required: true, message: t("choose_to") }]} label={t("to_location_with_options")}>
          <LocationPicker filterPredicate={(location) => location.type !== "UNKNOWN"} allowCreateNewLocation />
        </Form.Item>
      </Col>
    </Row>
  );
});

export default LocationsFormItems;
